const sc = {
    group: {
        header: {
            nav: {
                home: '主页',
                investor: '投资者关系',
                about: '关于我们',
                product: '产品',
                coffee: "猫屎咖啡",
                restaurant: "餐饮服务",
                join: "加入我们"
            },
            investor: {
                before: "2024年2月前",
                after: "2024年2月后"
            },
            hover: {
                food: {
                    title: "餐饮服务",
                    home: "主页",
                    about: "关于我们",
                    'wedding-information': "婚宴场地",
                    contact: "联系我们"
                },
                coffee: {
                    title: "猫屎咖啡",
                    home: "主页",
                    product: "咖啡商品",
                    coffee: "现制咖啡",
                    shop: "关于门店",
                    gourmet: "美味轻食",
                    boutique: "咖啡产品",
                    history: "历史",
                }
            }
        },
        home: {
            first: {
                title: "貓屎咖啡",
                content: "尤其是刚上线的产品，很难通过产品的内部体系来实现快速的用户增长，所以会更加依赖于分享来达到广泛的传播，获取目标用户"
            },
            second: {
                title: "产品展示",
                learnMore: "了解更多",
                product1: {
                    title: "貓屎咖啡",
                    content: "由麝香猫精心挑选的成熟咖啡果实，经独特的消化系统雕琢，成就一杯口感醇厚、香气浓郁且独一无二的奢华饮品，带你开启一场味蕾上的奇幻之旅"
                },
                product2: {
                    title: "餐饮服务",
                    content: "利宝阁/利宝会馆经营中式餐饮服务，业务遍布香港及内地。凭借对粤菜的热诚及食客为先的理念，集团以旗舰品牌「利宝阁」于中港两地开设酒家"
                }
            },
            three: {
                product1: {
                    title: "公司简介",
                    content: "利宝阁/利宝会馆经营中式餐饮服务，业务遍布香港及内地。凭借对粤菜的热诚及食客为先的理念，集团以旗舰品牌「利宝阁」于中港两地开设酒家"
                },
                product2: {
                    title: "关于猫屎咖啡",
                    content: "猫屎咖啡始终秉持精益求精的理念，从咖啡豆的种植、采摘、烘焙到成品的加工制作，每一个环节都严格把控"
                }
            },
            four: {
                title: "联系我们",
                address: "地址：香港九龙尖沙嘴广东道28虢力宝太阳广场3楼305室",
                email_title: "电邮：",
                desc1: '如果您有任何意见和建议',
                desc2: '请认真填写以下表单与我们联系',
                desc3: '我们将会尽快地回复您',
                name: '姓名',
                namePla: '联系姓名',
                email: 'E-email',
                emailPla: 'E-email地址',
                phone: '联系电话',
                phonePla: '联系电话',
                content: '留言',
                contentPla: '请输入您的留言',
                submit: '提交',
                tel:'电话：',
                fax:'传真：',
                rules: {
                    name: "请输入联系人名字",
                    phone: "请输入联系电话",
                    email: "请输入E-email地址",
                    content: '请填写留言内容',
                    emailReg: "请输入正确的E-email地址"
                }
            }
        },
        about: {
            title: "关于我们",
            desc: "我们的创业始于一家酒家，旨在为顾客提供最优质的食材、舒适的环境以及卓越的服务。我们深信，餐饮体验不仅仅是品尝美食，更是感受每一个细节所带来的愉悦与满足。\n" +
                "\n" +
                "随著我们的业务不断发展，我们引入了猫屎咖啡，这一选择旨在为顾客提供一种独特而难忘的咖啡体验。猫屎咖啡以其特殊的制作过程和独特的风味而闻名，让每一位顾客都能享受到与众不同的品味之旅。\n" +
                "我们希望通过这些精心挑选的产品，让每一位顾客都感受到独特的氛围和满意的体验",
            history: {
                title: "发展历程"
            }
        }
    },
    coffee: {
        header: {
            nav: {
                home: '主页', products: '产品', shop: '门店', boutique: "咖啡产品", history: "历史", more: '更多'
            }, hover: {
                first: "轻食", second: "咖啡商品", three: "现制咖啡"
            }
        },
        home: {
            first: {
                content: "猫屎咖啡为家庭和办公室的咖啡爱好者提供从咖啡器具、咖啡原料到咖啡制作方法的一站式解决方案",
                button: "查看集合"
            }, second: {
                title: "推荐商品", content1: "发现难忘的", content2: "咖啡风味"
            }, three: {
                title: "新鲜制作的咖啡饮品",
                content1: "芳香四溢的",
                content2: "美妙交响曲",
                desc: "精心制作并当场冲泡，为您带来新鲜制作的咖啡饮品的最纯粹精华，开启一场无与伦比的感官之旅"
            }, four: {
                title: "关于门店",
                content: "猫屎咖啡自2011年在广州开设首家门店以来，始终秉持精益求精的理念，从咖啡豆的种植、采摘、烘焙到成品的加工制作，每一个环节都严格把控。以其独有的咖啡风味和精细的制作工艺，迅速赢得了消费者的青睐，猫屎咖啡门店数量迅速增长，截至2024年，已在全国22个省市，未来将继续发展大湾区拓展业务，包括开店及咖啡衍生品的销售。通过打造闪送店、旗舰店、家族精品店等不同风格的门店，为消费者提供独特的空间体验"
            }, five: {
                title: "查看更多",
                first: {
                    title: "商店",
                    content1: "猫屎咖啡",
                    content2: "咖啡产品"
                }, second: {
                    title: "来历",
                    content1: "猫屎咖啡的",
                    content2: "由来"
                }, three: {
                    title: "轻食",
                    content1: "美味",
                    content2: "轻食"
                },
            }
        },
        boutique: {
            title1: "猫屎咖啡",
            title2: "家族精品店",
            content: "猫屎咖啡以高端精品咖啡产品以及咖啡衍生品售卖和品鉴为主，走轻奢路线。猫屎咖啡为家庭、办公咖啡爱好者提供从咖啡器具、咖啡原物料、咖啡制作方法一站式解决方案",
        },
        history: {
            title: "猫屎咖啡由来",
            content1: "“猫屎咖啡”，产于印尼苏门答腊群岛，一直以其稀有和独特延续着它的传奇。",
            content2: "十七世纪，荷兰殖民者把咖啡树苗引入到印度尼西亚。独特的地理环境以及温和的气候，苏门答腊群岛育出了优质的咖啡豆，可一种当地独有的野鼬喜吃成熟饱满的咖啡果，收获季节，咖啡园经常遭它们偷食，让本来赋税已经很重的咖啡农头疼不已，于是将其大量的驱赶和捕杀。\n",
            content3: "直到有一天，上尉Willemsen和往常一样带队执勤经过一农户时，远远就闻到一缕咖啡的醇香，他闯进农户院子，看到农夫正用铁锅炒着咖啡豆。正为收获不够咖啡豆数量而担心被上司责怪的Willemsen非常恼火，正要发飙的时候，却被农夫端过来的一杯黑咖啡所吸引。",
            content4: "刚入口，Willemsen就感到无比的顺滑醇厚，一种从未有过的甘香瞬间抨击着他的味蕾！当他看到农户指给他看的生豆时，更是目瞪口呆----竟然是野鼬排出体外的粪便! 原来当地农户喝不上园里收成的咖啡，看到地上有很多给野鼬吃了消化不了的咖啡豆，觉得可惜，就收集起来处理干净后自己享用，并称其为“猫屎咖啡”。",
            content5: "Willemsen回国时，把这些特殊的咖啡豆也带回了荷兰并进贡给他的贵族上司，立马就受到了荷兰贵族的青睐，之后一直成为只可皇室享用的贡品。这一切都要归功于造物主的神奇，咖啡果经野鼬体内自然发酵后产生了奇妙的变化，而野鼬的麝香腺体又赋予了咖啡豆独特的奇香。",
            content6: "从此，“猫屎咖啡”得以传世，当地的野鼬也得到了有效的保护。",
        },
        gourmet: {
            title: "美味轻食",
            content: "猫屎咖啡严格挑选新鲜食材，在致敬传统的同时融入创新。旨在为消费者带来前所未有的味蕾享受和健康体验。软糯的芝士蛋糕是健康早餐或下午茶的绝佳选择。",
            button: {
                title: "筛选",
            },
        },
        disclaimer: {
            title: '免责声明',
            t: "本网站所载资料只供参考，如有更改，恕不另行通知。本公司并不保证该等资料之准确性及完整性。对于使用或依赖本网站资料，或因经本网站连结所取得之其他互联网资料，所引致的任何损失，本公司概不负责。\n" +
                "‍\n" +
                "互联网使用者可自行复制、发布或传递有关资料作个人使用，唯不能作任何商业用途；使用时必须完整复制，并须标明资料来源。本公司不会就资料之使用负上任何责任。"
        },
        use: {
            title: "使用条款",
            t: "欢迎浏览猫屎咖啡控股有限公司(下称「猫屎咖啡」或「我们」或「我们的」)的网站。凡于使用条款及细则内提述「阁下」及「阁下的」包括进入本网站的任何人士。\n" +
                "‍\n" +
                "在使用本网站及其内容(下称「本网站」)前，请仔细阅读以下有关使用本网站的条款及细则(下称「使用条款」)。鉴于阁下使用本网站时，即表明阁下同意使用条款。我们有权于任何时间修订或更改使用条款。任何修订或更改将于本网站上发布。若阁下继续使用本网站，即表明接受该等修订或更改之约束。\n" +
                "‍\n" +
                "阁下同意不会(a)干扰或试图干扰我们的软件之正常运作或任何透过本网站而传送的任何服务；(b)在未经授权情况下，进入或试图进入我们的电脑系统或其他使用者的电脑系统；(c)收集或试图收集其他使用者的资料；或(d)作出任何导致或可能导致我们提供予使用者之服务受到中断或质量降低的行为或本网站被改变或涂污的行为。\n" +
                "‍\n" +
                "1. 拥有权\n" +
                "1.1 关于本网站及其设计之所有知识产权及商誉是属于我们或第三者或由我们或第三者已合法地获取特许/牌照用于本网站。阁下不得复制、复印、修改、更改、变更、修订、传送、载录、散布、分发、宣报、刊载或显示本网站或储存于检索系统或使用本网站制作任何衍生作品或销售本网站提供之产品或服务或侵犯我们或第三者的知识产权，惟阁下可将本网站任何部份下载一份至任何一部电脑作阁下之私人及非商业性用途，但阁下必须将所有版权及其他所有权声明完整地保留。使用条款在任何情况下，不会被诠释为向阁下授予任何属于我们或第三者之知识产权或商誉的权利、所有权或权益。我们或第三者特此保留一切适用法律之权利。\n" +
                "‍\n" +
                "1.2 阁下同意在未得我们事先书面同意之前，不可将本网站显示在框格(frame)或与本网站连结(link)或将阁下与本网站相联。\n" +
                "‍\n" +
                "2. 内容\n" +
                "猫屎咖啡经已作出一切合理安排以确保本网站所提供之资讯及资料均为正确及最新的。但是，我们否认所有明示或隐含的保证，并不会就该等资讯及资料之准确性、适时性、充足性、可靠性或完整性作出任何表述。\n" +
                "‍\n" +
                "3. 本网站之使用\n" +
                "3.1 阁下不得滥用本网站，借本网站引进病毒、蠕虫病毒(worms)、逻辑炸弹病毒、恶意的或技术上有害的或含有污染或破坏元素的其他材料。阁下在未经许可情况下，不得存取或试图存取本网站、储存本网站之伺服器或电脑、或与本网站相连之任何伺服器、电脑或资料库。\n" +
                "‍\n" +
                "3.2 阁下不得利用本网站传送虚假、非法、骚扰性、诽谤性、辱骂性、憎恨性、歧视的、威吓的、有害的、粗俗的、猥亵的、煽动性或其他引起反对或冒犯性之任何种类或性质的材料。\n" +
                "‍\n" +
                "3.3 阁下同意只可使用本网站作非商业性、个人及合法之用途。\n" +
                "‍\n" +
                "3.4 因阁下使用本网站而导致任何病毒、蠕虫病毒(worms)、逻辑炸弹病毒、含有污染或破坏元素的材料或其他恶意或技术上有害的材料有可能影响阁下的设备、资料库或其他材料所产生的任何损失或损害，我们概不负责。\n" +
                "‍\n" +
                "3.5 我们保留权利可在不作通知的情况下，于任何时间终止阁下进入本网站或拒绝让阁下使用本网站或其服务。\n" +
                "‍\n" +
                "4. 个人资料收集声明\n" +
                "当阁下使用本网站，阁下可能向我们提供你的个人资料。阁下同意所提供的该等个人资料乃属自愿性质。我们有权因应收集目的及适用法律继续保留该等个人资料。我们会根据我们的私隐政策使用阁下的个人资料，阁下亦同意接受我们的私隐政策，有关政策可从私隐政策连结参阅。阁下确认阁下所提供的资料是属实、正确、有效和完整的。\n" +
                "‍\n" +
                "5. 保证及法律责任\n" +
                "5.1 阁下同意是在风险自负之情况下使用本网站。就使用本网站、依靠本网站提供有关猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴之任何资讯或资料、本网站遗漏任何有关猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴之资讯或资料、任何上载至本网站的材料或与本网站之连结，我们概不负责。\n" +
                "‍\n" +
                "5.2 我们没有代表任何第三者之授权。阁下同意我们不会就阁下与第三者之任何索偿、纠纷、偿付或合约承担任何责任。\n" +
                "‍\n" +
                "5.3 本网站之资料是按\"现状\"提供的，当中并没有包含任何明确或隐含保证。我们可在不作事先通知的情况下，于任何时间对其作出更改。\n" +
                "‍\n" +
                "5.4 我们不就下述情形作出任何明示或隐含的声明或保证:\n" +
                "(a)本网站可于任何时间在持续及不被中断之基础上可供存取或本网站之运作、品质及供存取性能；\n" +
                "(b)本网站或任何透过本网站取得的材料是没有病毒、蠕虫病毒(worms)、逻辑炸弹病毒、恶意或技术上有害的材料或含有污染或破坏元素的材料包括但不限于该等病毒或其他程式会令阁下之资料或财产受损；\n" +
                "(c)使用本网站将取得任何特定结果；及\n" +
                "(d)纠正本网站的任何不足之处。\n" +
                "‍\n" +
                "5.5 若阁下因使用本网站而须更换任何设备或软件或资料库受损，我们概不负责。\n" +
                "‍\n" +
                "5.6 因使用或不能使用本网站或使用或依靠本网站之任何资讯而导致的任何损失(不论直接、间接、特殊或必然的)、损害或伤害(不论是否合约、侵权(包括疏忽)、违反法定责任或其他行为)，即使是可预见的，阁下同意豁免我们的法律责任或将其减至法律范围内最低。为免生疑，使用条款并不免除或局限我们因我们、我们的雇员或代理人之疏忽或欺诈或失实陈述所引致死亡或人身伤害的责任。\n" +
                "‍\n" +
                "5.7 于互联网上传递之讯息并不保证绝对安全；同时，阁下因透过互联网向猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴传送讯息或要求猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴透过互联网向阁下发出之讯息如有任何延误、损失、误传、变更或损毁，我们对此而引致之损失或损害，概不负责。\n" +
                "‍\n" +
                "6. 弥偿\n" +
                "因阁下违反使用条款、或不遵守使用条款或透过本网站而取得的任何材料所引致的任何责任，阁下同意完全弥偿我们、我们之附属公司、母公司、雇员及代理人因此所引致的全部申索、损失、损害、费用及支出(包括法律费用)，并就任何申索、损失、损害、费用及支出(包括法律费用)为我们、我们之附属公司、母公司、雇员及代理人进行抗辩。\n" +
                "‍\n" +
                "7. 可分割性\n" +
                "使用条款的任何条文在某司法管辖区的法律若属不合法、无效或无法执行，将不影响该有关条文在其他司法管辖区的合法性、有效性及可执行性，同时，也不会影响其他条文的合法性、有效性及可执行性。\n" +
                "‍\n" +
                "8. 一般事项\n" +
                "8.1 本使用条款的中英文本如有任何矛盾或不一致，应以中文本为准，英文仅供参考。\n" +
                "‍\n" +
                "8.2 本使用条款根据香港特别行政区(\"香港\")法律诠释，并受香港法律管辖。就使用条款或阁下使用本网站所引致的任何纠纷，阁下同意香港法庭享有专有司法管辖权。\n" +
                "‍\n" +
                "9. 杂项\n" +
                "任何违反事项之宽免并不构成对其他违反事项之宽免。使用条款内之标题仅为方便参考而设，不影响使用条款的诠释。"
        },
        desc: {
            title: "私隐政策及声明",
            t: "本声明旨在说明猫屎咖啡控股有限公司(「猫屎咖啡」或下称「我们」或「我们的」)透过位于http://kafelaku.com的网页(下称「本网站」)就有关收集阁下的个人资料(下称「资料」)及其使用的处理方法。凡于本声明内「阁下」或「阁下的」包括进入本网站及提交资料的任何人士。\n" +
                "‍\n" +
                "请仔细阅读本声明。鉴于阁下使用本网站或向我们递交阁下的资料，即表明阁下同意接受本声明。我们有权于任何时间修订或更改本声明。任何修订或更改将于本网站上发布。在本声明修订或更改后，若阁下继续使用本网站，即表明接受该等修订或更改之约束。无论如何，若有任何修订或更改关于我们如何收集及使用阁下的资料，我们会在作出该修订或更改前向阁下取得同意。\n" +
                "‍\n" +
                "1. 个人资料(私隐)条例\n" +
                "就阁下的资料之收集、运用、贮存、保留、披露、转移、提供、供存取、保护及存取，我们遵守个人资料(私隐)条例(香港特别行政区法例第486章)所述的规定。\n" +
                "‍\n" +
                "2. 收集资料及资讯\n" +
                "2.1 当阁下使用本网站，我们可能向阁下收集资料，包括但不限于阁下的姓名、地址、联络资料(包括电话、流动电话及传真号码)、信用咭资料(若阁下订购我们的产品或服务) 、电邮地址、网际网路通讯协议(IP)地址、操作系统的类型、浏览器类别、域名、登入时间及与阁下要求获取资料或服务有关的其他人士的其他资料，并会作下列用途:\n" +
                "(a) 就招聘、产品及服务提供及/或顾客服务之用途作身份核实及纪录；\n" +
                "(b) 以达成阁下对我们的产品或服务订购要求，并处理订单、付款及任何帐项偿付；\n" +
                "(c) 于我们的内部数据库保存通讯联络资料；\n" +
                "(d) 汇制本网站使用量的统计；\n" +
                "(e) 回应及处理阁下的任何查询或执行阁下的要求；\n" +
                "(f) 对我们的产品及服务作出评估及提升；及\n" +
                "(g) 进行与我们客户、产品、服务、活动、推广或项目有关的调查。\n" +
                "‍\n" +
                "2.2 阁下确认并同意阁下提供的资料属自愿性质。\n" +
                "‍\n" +
                "2.3 阁下可以发送电邮至enquiry@kafelaku.com，随时更改阁下就收取我们的资讯及资料所作的选择或阁下的资料。\n" +
                "‍\n" +
                "3. 使用资料作直接促销\n" +
                "3.1 我们亦会使用阁下的资料向阁下发送直接促销讯息，例如当中包含关于食品、饮料、餐饮产品及服务的消息、报价和推广之邮件、电子邮件、电话或短信。\n" +
                "‍\n" +
                "3.2 我们不会在未得阁下之书面同意前向任何第三方提供阁下的资料作直接促销用途。\n" +
                "‍\n" +
                "3.3 如阁下不欲收取任何直接促销讯息，请随时将你的要求连同你的姓名发送电邮至enquiry@kafelaku.com。\n" +
                "‍\n" +
                "4. 保安\n" +
                "我们会使用适当的安全技术及程序以保护阁下的资料，避免在未经授权情况下被存取、使用或披露。惟鉴于互联网之性质及技术，其他人仍有可能截取阁下发送至或传经本网站的资讯。我们不保证本网站不受黑客入侵或攻击。\n" +
                "‍\n" +
                "5. 披露、保留及贮存资料\n" +
                "5.1 阁下确认、同意并授权我们把资料保留及贮存在我们的一个或多个在香港境内或外的数据库内。\n" +
                "‍\n" +
                "5.2 除非阁下事先同意或法律允许，我们不会向任何第三方转移、披露、提供或供存取阁下的资料，惟下文所述情况除外：\n" +
                "(a)我们之附属公司为专业机构膳食有限公司；\n" +
                "(b)我们的雇员；\n" +
                "(c)信贷公司​​以进行付款交易；\n" +
                "(d)按适用法律、法庭命令、行政政策或规例、指引、指令或于香港或香港以外的任何监管、政府、税务、执法或其他机构，或自律规管团体或业界团体所颁布或发布的命令，或与法律程序有关，或为在香港确立、行使或抗辩的法律权利，要求我们必须向其披露之任何人士或机构；\n" +
                "(e)就我们的业务、合并、收购或转让而作出尽职审查为目的，而须予以披露之任何人士、机构或个体；\n" +
                "(f)因危及生命或紧急情况下并有助于识别个人为由，我们须向有关人士、机构、个体或机关作出披露。\n" +
                "阁下确认、同意并授权我们在执行，实施或遵守我们之使用条款及细则的任何条款或本声明的情况下转移、披露、提供或供存取阁下的资料。\n" +
                "‍\n" +
                "6. 查阅及更正资料\n" +
                "阁下有权查阅我们是否持有有关你的资料并存取任何该等资料，如有需要，阁下亦有权要求更正或更新该等资料。倘若阁下希望存取、更正或更新阁下的资料，请发送电邮至enquiry@kafelaku.com。在符合《个人资料(私隐)条例》之下我们会致力于40天内对阁下的要求作出回应。\n" +
                "‍\n" +
                "7. 曲奇档案(Cookies)\n" +
                "我们可能在本网站上使用曲奇档案。曲奇档案是由网站自动储存于个人电脑网络浏览器的小量资料，这些资料可以由该网站检索。曲奇档案所收集的信息是匿名的聚集研究数据，并没有包含名称或地址信息或使任何人可以通过电话，电子邮件或任何其他方式与阁下联系之任何信息。大多数浏览器最初设定都接受曲奇档案。倘若阁下希望停止曲奇档案的运作，阁下可以更改阁下的浏览器设定。无论如何，由于本网站的某些功能需要曲奇档案方能运作，例如：在过程中保持连续性，如果它们被停止，这些功能可能无法正常运作，这样或会使我们的部份网页不能正确或完全不能显示。\n" +
                "‍\n" +
                "8. 未成年人士\n" +
                "我们没有责任查证阁下的年龄，并假定阁下已年满十八岁或以上。若阁下年龄未满十八岁，或无能力缔结合约，在未得到你的父母/监护人事前同意情况下，阁下不应在本网站提供任何阁下的资料。我们建议儿童/未成年人士须在父母/监护人监督下上网。\n" +
                "‍\n" +
                "9. 一般事项\n" +
                "本声明的中英文本如有任何矛盾或不一致，应以中文本为准，英文仅供参考。\n" +
                "‍\n" +
                "10. 其他问题\n" +
                "倘若阁下有任何与本声明有关的查询，请发送电邮至enquiry@kafelaku.com。"
        }
    },
    footer: {
        disclaimer: '免责声明',
        use: '使用条款',
        desc: '隐私政策以及声明',
        company: "猫屎咖啡控股有限公司"
    },
    relations: {
        title: "投资者关系",
        more: "查看更多",
        search: "请输入文件或标题关键字",
        announcement: "公告",
        circulars: "通函",
        'financial-report': "财务报告",
        others: "其他",
        empty: "空数据",
        company: "貓屎咖啡控股有限公司",
        code: "股份代号：1869",
        email: "电邮：",
        desc: `集團經營咖啡及中式餐飲服務，业务遍布香港及内地。
猫屎咖啡始终秉持精益求精的理念，从咖啡豆的种植、采摘、烘焙到成品的加工制作，每一个环节都严格把控。
凭借对粤菜的热诚及食客为先的理念，集团以旗舰品牌「利宝阁」和「利宝会馆」于中港两地开设酒家`
    }
}

export default sc